import Header from "../../components/header";
import Footer from "../../components/footer";
import FAQ from "../../components/faq";
import BrandList from '../../components/brand-list';
import "./style.scss";

function Home() {
  return (
    <>
      <Header channel={'home'} />

      <div className="l-container">
        <div className="landing-info">
          <h1>Vi kan inte hitta sidan du letar efter</h1>
          <p>Tyvärr kan vi just nu inte visa sidan du ville nå. Det beror på att vi genomför uppdateringar eller upplever tekniska problem. Så snart det är möjligt kommer allt fungera igen.
            Behöver du komma i kontakt med oss? Gå direkt till kontaktuppgifterna för respektive företag/sajt nedan.
            Läs mer i Frågor och svar längre ned på denna sida.</p>
        </div>
      </div>

      <BrandList />

      <FAQ />

      <Footer />
    </>
  );
}

export default Home;
